import React, { useState, useEffect, useCallback } from "react";
import Moment from "react-moment";
//import studyList from './data.json';

function ImagingStudyList() {
  let AccessToken = localStorage.getItem("AccessToken");
  let AccessTokenInbox = localStorage.getItem("AccessTokenInbox");
  let NodeServerHost = process.env.REACT_APP_NODE_API_URL;
  let CareCode = localStorage.getItem("CareCode");
  let OperatingId = process.env.REACT_APP_OperatingId;
  let orgId = localStorage.getItem("orgId");
  let patientId = localStorage.getItem("PatientId");  
  const [hasError, setHasError] = useState(false);
  const [message, setMessage] = useState();
  const [studyList, setStudyList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const guestLinkJson = JSON.parse(localStorage.getItem("GuestLinkValidateJson"));
  let linkId = guestLinkJson?.id;
  let orgIdGuest = guestLinkJson?.organizationId;

  useEffect(() => {
    setIsLoading(true);
    //console.log(localStorage.getItem('AccessToken'))
    if(AccessToken != null){
      //For actual patient logged in data
      //console.log("Patient Study")
      fetch(NodeServerHost + `/Study`, {
        method: "GET",
        headers: {
          OrganizationId: orgId,
          CareCode: CareCode,
          // OperatingId: OperatingId,
          Subject: `_include=ImagingStudy:subject&_include=ImagingStudy:referrer&_total=accurate&_sort=-_lastUpdated&_elements=id,identifier,subject,name,gender,birthDate,modality,description,status,started,numberOfInstances,reasonReference,referrer,extension,location,resultsInterpreter&_tag=${encodeURIComponent(patientId)}&_count=10`,
          Authorization: "Bearer " + AccessToken,
          "Content-Type": "application/json", 
        }
      })
      .then((response) => response.json())
      .then((responseData) => {
        //console.log(responseData);
        setIsLoading(false);
        setStudyList(responseData);
      })
      .catch(error => console.error('Error:', error));      
    }
    else if(AccessTokenInbox != null){
      //For guest logged in data
      //console.log("Guest Study")
        fetch(NodeServerHost + `/Link/ImagingStudy`, {
          headers: {
            OrganizationId: orgId,
            CareCode: CareCode,
            OperatingId: OperatingId,
            LinkId: linkId,
            Authorization: "Bearer " + AccessTokenInbox,
            "Content-Type": "application/json",
          },
        })
        .then((response) => response.json())
        .then((responseData) => {
          //console.log(responseData);
          setIsLoading(false);
          //setStudyList(responseData);
        });
    }
  }, []);

  console.log(studyList);

  
  const GetViewer = (e) => {
    //console.log(e.currentTarget.dataset.imagingid)
    //console.log(e.currentTarget.dataset.foldercorelation)
    console.log(e.currentTarget.dataset.diagnosticviewer)
    localStorage.setItem("DiagnosticViewerFlag", e.currentTarget.dataset.diagnosticviewer);
    fetch(NodeServerHost + `/ImageViewer`, {
      method: "POST",
      headers: {
        OrganizationId: orgId,
        CareCode: CareCode,
        OperatingId: OperatingId,
        ImagingStudyId: e.currentTarget.dataset.imagingid,
        FolderCoRelationId: e.currentTarget.dataset.foldercorelation,
        Authorization: "Bearer " + localStorage.getItem("AccessTokenGuest"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ImagingStudyId: e.currentTarget.dataset.imagingid,
        FolderCoRelationId: e.currentTarget.dataset.foldercorelation,
        UserName:""
      })
    })
    .then((response) => response.json())
    .then((responseData) => {
      //console.log(responseData);
      if(responseData.status == "Error"){
        setMessage("Error");
        setTimeout(() => {
          setMessage("")
        }, 3000)
      }else{
        if(localStorage.getItem("DiagnosticViewerFlag") == 'true'){
          let url = "https://interface.care.io/diagnosticviewer/?study=" + responseData;//1.2.840.114202.4.3974217366.2139118078.3516278751.1551829984";   
          window.open(url, "_blank"); 
        }else if(localStorage.getItem("DiagnosticViewerFlag") == 'false'){
          let url = "https://viewer.care.io/viewer/" + responseData;//1.2.840.114202.4.3974217366.2139118078.3516278751.1551829984";
          window.open(url, "_blank"); 
        }
      }
      
    })
    .catch((err) => setHasError(true));
  }


  //const [count, setCount] = useState(0);
  const [todos, setTodos] = useState([]);

  // const increment = () => {
  //   setCount((c) => c + 1);
  // };

  const DownloadStudy = useCallback((e) => {
    // const downloadOptions = {
    //   method: "POST",
    //   headers: {
    //     OrganizationId: e.currentTarget.dataset.organizationid,
    //     CareCode: CareCode,
    //     OperatingId: OperatingId,
    //     ImagingStudyId: e.currentTarget.dataset.imagingid,
    //     FolderCoRelationId: e.currentTarget.dataset.foldercorelation,
    //     Authorization: "Bearer " + AccessToken,
    //     "Content-Type": "application/text",
    //   },
    // };

    // const initialJsonData = {
    //   nextPartitionKey:null,
    //   nextRowKey: null,
    //   nextTableName: null,
    //   targetLocation: null
    // }
  
    // fetch(NodeServerHost + `/Download`, downloadOptions, {
    //   body: JSON.stringify(initialJsonData)
    // })
    // .then((response) => response.json())
    // .then((responseData) => {
    //   console.log(responseData);
    // })
    // .catch((err) => setHasError(true));

    fetch(NodeServerHost + `/Download`, {
      method: "POST",
      headers: {
        OrganizationId: e.currentTarget.dataset.organizationid,
        CareCode: CareCode,
        OperatingId: OperatingId,
        ImagingStudyId: e.currentTarget.dataset.imagingid,
        FolderCoRelationId: e.currentTarget.dataset.foldercorelation,
        Authorization: "Bearer " + AccessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        nextPartitionKey:null,
        nextRowKey: null,
        nextTableName: null,
        targetLocation: null
      })
    })
    .then((responseData) => {
      console.log(responseData);
      
    });

    setTodos((t) => [...t, "New Todo"])
    
  },[todos]);

  //console.log(studyList)
  

  
  return (
    <div>
      <div className={message === 'Error' ? 'alert alert-warning alert-dismissible messageinfo fade show' : 'alert alert-warning alert-dismissible fade d-none'} role="alert">
        {message}
        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      <h4 className="p-3 mb-0 float-start"><small>Imaging Study</small></h4>
      
      <div className="col col-lg-12 pe-3 ps-3">
        <table className="table">
          <thead>
            <tr className="table-active">
              <th>Patient Name</th>
              <th>Study Description</th>
              <th>Study Date</th>
              <th>Upload Date</th>
              <th>Actions </th>
            </tr>
          </thead>
          {isLoading === true && (
            <tbody>
              <tr>
                <td colSpan="5">
                  <div className="spinner-border" role="status"></div>Loading...
                </td>
              </tr>
            </tbody>
          )}
          {isLoading === false && (
            <tbody>
              {studyList === "No records found"
              ? <tr>
                  <td colSpan="5">
                    {studyList}
                  </td>
                </tr>
              : studyList?.map((imagingstudy) => {
                  if (imagingstudy.resourceType === "ImagingStudy") {
                    const lastUpdatedTime = imagingstudy.meta.lastUpdated.split(".");
                    
                    const metatag = imagingstudy.meta.tag.map((tag) => {
                      if (tag?.system === "TargetOrganizationId") {
                        return tag.code;
                      }
                    })
                    
                    //const organizationid = 
                    const organizationid = metatag.filter((element) => {
                      return element !== undefined;
                    });
                    //console.log(organizationid);
                    
                    const imagingstudyAccession = imagingstudy.identifier.map((id) => {
                      if (id.type?.text === "Accession ID") {
                        return id.value;
                      }
                    })
                    const accessionNumber = imagingstudyAccession.filter((element) => {
                      return element !== undefined;
                    });

                    const imagingstudyFoldercorelationId = imagingstudy.identifier.map((id) => {
                      if (id?.system === "FolderCorelation") {
                        return id.value;
                      }
                    })
                    const FolderCoRelationId = imagingstudyFoldercorelationId.filter((element) => {
                      return element !== undefined;
                    });



                    const matchedObject = studyList.find(obj1 => {
                      return studyList.some(obj2 => obj2.id === obj1?.subject?.reference.split("/")[1]);
                    });

                    console.log(matchedObject);

                    const patientInfo = studyList?.map((resource) => {
                      var patientRef = ""
                      if (resource.resourceType === "ImagingStudy") {
                        patientRef = resource.subject.reference.split("/")[1];
                      }
                      
                      //const matchId = studyList.find(obj => obj.id === patientRef)
                      //console.log(matchId)

                      if (resource.resourceType === "Patient") {
                        const mrn = resource.identifier.map((id) => {
                          //console.log(id.type.text);
                          if (id.type?.coding[0]?.code === "MR") {
                            return id.value;
                          }
                        });
                        const patientId = resource.id;

                        //const matchId = resource.find(obj => obj.id === patientId)
                        
                        return {
                          patientId: resource.id,
                          patientName: resource.name[0].given[0] + " " + resource.name[0].family,
                          patientDOB: resource.birthDate,
                          patientGender: resource.gender,
                          patientMRN: mrn[0]
                        };
                      }
                      
                    });

                    

                    const patientData = patientInfo.filter((element) => {
                      return element !== undefined;
                    });

                    //console.log(patientData)

                    // const matchedObject = studyList.find(obj1 => {
                    //   return patientData.some(obj2 => obj2.patientId === obj1.id);
                    // });
                    // console.log(matchedObject)

                    //const matchedObject = imagingstudy.find(obj => obj.id === idToMatch);

                    return (
                      <tr key={imagingstudy.id}>
                        <td className="hyperlinkView">
                          <span>
                            <strong>{patientData[0]?.patientName}</strong>
                          </span>
                          <br></br>
                          <span className="text-secondary">
                            {patientData[0]?.patientGender === ""
                              ? ""
                              : patientData[0]?.patientGender === "male"
                              ? "( M )"
                              : patientData[0]?.patientGender === "female"
                              ? "( F )"
                              : patientData[0]?.patientGender === "other"
                              ? "( O )"
                              : ""}{" "}
                            DOB{" "}
                            <Moment format="MM/DD/YYYY">
                              {patientData[0]?.patientDOB}
                            </Moment>
                          </span>
                          <br></br>
                          <span className="text-secondary">
                            MRN {patientData[0]?.patientMRN}
                          </span>
                        </td>
                        <td className="hyperlinkView">
                          <strong>{imagingstudy.description}</strong>
                          <br></br>
                          <span className="text-secondary">
                            {imagingstudy.modality[0].display} &nbsp; Acc#: {accessionNumber[0]}
                          </span>
                        </td>
                        <td>
                          <Moment format="MM/DD/YYYY">
                            {imagingstudy.started}
                          </Moment>
                          <br></br>
                          <Moment
                            className="text-secondary"
                            parse="YYYY-MM-DD HH:mm"
                            format="hh:mm a"
                          >
                            {imagingstudy.started}
                          </Moment>
                        </td>
                        <td>
                          <Moment format="MM/DD/YYYY">
                            {imagingstudy.meta.lastUpdated}
                          </Moment>
                          <br></br>
                          <Moment className="text-secondary" format="hh:mm a">
                            {lastUpdatedTime[0]}
                          </Moment>
                        </td>
                        <td className="row-actions study">
                          <div className="btn-group actionBtn float-start mt-3 me-4">
                          {/* data-organizationid="ead79671-ce66-44e9-90ba-83ef4bdc8ad7" data-imagingid="67f80ce5-05a7-4821-bb69-845676267826" data-foldercorelation="1000137537" */}
                            <a href="javacript:void(0)" onClick={GetViewer} data-diagnosticviewer='false' data-organizationid={organizationid[0]} data-imagingid={imagingstudy.id} data-foldercorelation={FolderCoRelationId} className="btn dropdown-toggle icon-action no-droparrow disabled" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="icon-action vieweye-icn"></i>
                              <span>View</span>
                              <span className="caret"></span>
                            </a>
                            <div className="dropdown-options disabled">
                              <a href="javacript:void(0)" onClick={GetViewer} data-diagnosticviewer='true' data-organizationid={organizationid[0]} data-imagingid={imagingstudy.id} data-foldercorelation={FolderCoRelationId}>Diagnostic Viewer</a>
                            </div>
                          </div>
                          <div className="btn-group actionBtn float-start ms-2 mt-3 me-4 disabled">
                            <a href="javacript:void(0)" className="btn dropdown-toggle icon-action no-droparrow" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="icon-action reports-icn"></i>
                              <span>Reports</span>
                            </a>
                          </div>
                          <div className="btn-group actionBtn float-start mt-3 me-4 disabled">
                            <a href="javacript:void(0)" onClick={DownloadStudy} data-organizationid={organizationid[0]} data-imagingid={imagingstudy.id} data-foldercorelation={FolderCoRelationId}  className="btn dropdown-toggle icon-action no-droparrow" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="icon-action download-icn"></i>
                              <span>Download</span>
                            </a>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                })}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
}

export default ImagingStudyList;
